import { borderRadius } from '@toggle/design-system';
import styled from 'styled-components';

export const MedianBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
`;

export const MedianBadge = styled.p`
  background-color: var(--surface-neutral);
  ${borderRadius.rFull}
  font-family: var(--font-nort);
  font-size: 9px;
  line-height: 12px;
  color: var(--surface-white);
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
